import React, { useEffect } from "react";
import { Area } from "../../models/Area";
import { Dropoff } from "../../models/Dropoff";
import { Equipment } from "../../models/Equipment";
import { Gate } from "../../models/Gate";
import { HaulRoute } from "../../models/HaulRoute";
import MapObjectAttachmentsSlider from "../Map/MapObjectAttachments/MapObjectAttachmentsSlider";
import MapObjectIframeViewer from "../Map/MapObjectAttachments/MapObjectIframeViewer";

interface DamnMappableAttachmentsProps {
    mappable: Area | Dropoff | Equipment | Gate | HaulRoute | null;
}

const DamnMappableAttachments: React.FC<DamnMappableAttachmentsProps> = ({ mappable }) => {
    const [iframe, setIframe] = React.useState<string | null>(null);
    // Optimistically true so the container doesn't flash empty while attachments are still loading;
    // MapObjectAttachmentsSlider corrects this once it knows whether there are any.
    const [hasAttachments, setHasAttachments] = React.useState<boolean>(true);

    useEffect(() => {
        setHasAttachments(true);

        if (!mappable) {
            setIframe(null);
            return;
        }

        if (mappable instanceof Area) {
            setIframe(mappable.attachmentMethod === "iframe" && mappable.areaIframe ? mappable.areaIframe : null);
        } else if (mappable instanceof Dropoff) {
            setIframe(mappable.attachmentMethod === "iframe" && mappable.dropoffIframe ? mappable.dropoffIframe : null);
        } else if (mappable instanceof Equipment) {
            setIframe(
                mappable.attachmentMethod === "iframe" && mappable.equipmentIframe ? mappable.equipmentIframe : null
            );
        } else if (mappable instanceof Gate) {
            setIframe(mappable.attachmentMethod === "iframe" && mappable.gateIframe ? mappable.gateIframe : null);
        } else if (mappable instanceof HaulRoute) {
            setIframe(
                mappable.attachmentMethod === "iframe" && mappable.haulRouteIframe ? mappable.haulRouteIframe : null
            );
        }
    }, [mappable]);

    if (!mappable || (!iframe && !hasAttachments)) return null;

    return (
        <div className="w-full h-auto max-h-48 xl:w-48 xl:h-auto xl:max-h-full shrink-0 overflow-hidden rounded-lg flex items-center justify-center">
            {iframe ? (
                <MapObjectIframeViewer iframe={iframe} />
            ) : (
                <MapObjectAttachmentsSlider
                    currentObject={mappable}
                    hideEmptyState
                    onEmptyChange={(isEmpty) => setHasAttachments(!isEmpty)}
                />
            )}
        </div>
    );
};

export default DamnMappableAttachments;
